// Listado de coberturas médicas (Argentina): obras sociales (RNOS — Registro
// Nacional de Obras Sociales, y provinciales) y prepagas (RNAS — Registro Nacional
// de Agentes del Seguro / RNEMP). Se guarda el nombre tal cual en
// profiles.health_insurance_name (paciente / familiar) y en
// profiles.accepted_health_insurances (profesional / institución).
// Para sumar entidades, agregarlas acá (orden alfabético dentro de cada grupo).
// La comparación usa la sigla (lo que está antes de " (") normalizada, así
// "PAMI" cargado a mano antes del listado matchea con "PAMI (INSSJP)".

export const PREPAID_PLANS = [
  "Accord Salud",
  "Avalian (ex ACA Salud)",
  "Bristol Medicine",
  "CEMIC",
  "Doctored",
  "Federada Salud",
  "Galeno",
  "Hominis",
  "Hospital Alemán (Plan Médico)",
  "Hospital Británico (Plan de Salud)",
  "Hospital Italiano (Plan de Salud)",
  "Jerárquicos Salud",
  "Luis Pasteur",
  "Medicus",
  "Medifé",
  "Nubial",
  "Omint",
  "OSDE",
  "Premedic",
  "Prevención Salud",
  "Sancor Salud",
  "Swiss Medical",
  "William Hope",
];

export const SOCIAL_SECURITY_PLANS = [
  "APROSS (Córdoba)",
  "DOSEP (San Luis)",
  "DOSUBA (Universidad de Buenos Aires)",
  "IAPOS (Santa Fe)",
  "IOMA (Provincia de Buenos Aires)",
  "IOSFA (Fuerzas Armadas y de Seguridad)",
  "IPROSS (Río Negro)",
  "ISSN (Neuquén)",
  "ObSBA (Ciudad de Buenos Aires)",
  "OSBA (Bancarios)",
  "OSCHOCA (Camioneros)",
  "OSDEPYM (Empresarios PyME)",
  "OSECAC (Empleados de Comercio)",
  "OSEF (Tierra del Fuego)",
  "OSEP (Mendoza)",
  "OSER (Entre Ríos)",
  "OSFATLYF (Luz y Fuerza)",
  "OSMATA (Mecánicos del Automotor)",
  "OSPACP (Actividad Cervecera)",
  "OSPE (Petroleros)",
  "OSPECON (Construcción)",
  "OSPEDYC (Entidades Deportivas y Civiles)",
  "OSPERYH (Encargados de Edificios)",
  "OSPIA (Industria de la Alimentación)",
  "OSPIM (Industria Maderera)",
  "OSPJN (Poder Judicial de la Nación)",
  "OSPLAD (Docentes)",
  "OSPRERA (Trabajadores Rurales)",
  "OSSEG (Seguros)",
  "OSUOMRA (Metalúrgicos - UOM)",
  "OSUTHGRA (Gastronómicos)",
  "PAMI (INSSJP)",
  "Unión Personal (Civiles de la Nación)",
];

export const HEALTH_INSURANCE_GROUPS = [
  { key: "prepaid", labelKey: "app.insurance.groupPrepaid", labelDefault: "Prepagas", items: PREPAID_PLANS },
  { key: "social", labelKey: "app.insurance.groupSocial", labelDefault: "Obras sociales", items: SOCIAL_SECURITY_PLANS },
];

export const HEALTH_INSURANCES = [...PREPAID_PLANS, ...SOCIAL_SECURITY_PLANS].sort(
  (a, b) => a.localeCompare(b, "es")
);

/** Clave de comparación: sigla/nombre antes de " (", sin acentos ni mayúsculas. */
export function insuranceKey(name) {
  if (!name || typeof name !== "string") return "";
  return name
    .split(" (")[0]
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/gi, " ")
    .trim()
    .toLowerCase();
}

export function sameInsurance(a, b) {
  const ka = insuranceKey(a);
  return !!ka && ka === insuranceKey(b);
}

/** Nombre del listado que corresponde a un valor cargado (o el valor tal cual). */
export function canonicalInsuranceName(name) {
  if (!name) return "";
  return HEALTH_INSURANCES.find((item) => sameInsurance(item, name)) || name.trim();
}

/**
 * Coberturas que atiende un profesional: las propias más las de la institución
 * donde tiene agenda compartida (si la hay).
 */
export function getAcceptedInsurances(doctor, institution) {
  const own = Array.isArray(doctor?.accepted_health_insurances)
    ? doctor.accepted_health_insurances
    : [];
  const inst = Array.isArray(institution?.accepted_health_insurances)
    ? institution.accepted_health_insurances
    : [];
  return [...own, ...inst];
}

/** ¿El profesional atiende por esta cobertura? (false si el paciente no tiene). */
export function acceptsInsurance(acceptedList, insuranceName) {
  if (!insuranceName) return false;
  return (acceptedList || []).some((item) => sameInsurance(item, insuranceName));
}
